import Swiper, {Autoplay, Navigation, Thumbs, Pagination, Controller} from 'swiper';

Swiper.use([Autoplay, Navigation, Thumbs, Pagination, Controller]);

export default {
    professionals: () => {
        new Swiper('.professionals', {
            slidesPerView: 1,
            navigation: {
                nextEl: '.swiper-button-professional-next',
                prevEl: '.swiper-button-professional-prev',
            },
        });
    },

    news: () => {
        new Swiper('.news', {
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: '.swiper-button-news-next',
                prevEl: '.swiper-button-news-prev',
            },
            pagination: {
                el: '.swiper-pagination-news',
                type: 'bullets',
            },
            breakpoints: {
                768: {
                    pagination: false,
                    navigation: false,
                    slidesPerView: 2,
                    allowTouchMove: false,
                },
            }
        })
    },

    productgroups: () => {
        new Swiper('.productgroups', {
            slidesPerView: 2,
            spaceBetween: 30,
            centeredSlides: true,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-highlight-next',
                prevEl: '.swiper-button-highlight-prev',
            },
            autoplay: {
                delay: 5000,
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    centeredSlides: false,
                },
                1024: {
                    autoplay: false,
                    navigation: false,
                    slidesPerView: 4,
                },
                1440: {
                    slidesPerView: 5,
                },
                1536: {
                    slidesPerView: 6,
                }
            }
        });
    },

    brands: () => {
        new Swiper('.brands', {
            slidesPerView: 2,
            spaceBetween: 30,
            centeredSlides: true,
            loop: true,
            autoplay: {
                delay: 3000,
            },
            breakpoints: {
                768: {
                    slidesPerView: 4,
                },
                1024: {
                    centeredSlides: false,
                    slidesPerView: 5,
                },
            }
        });
    },

    products: () => {
        new Swiper('.products', {
            slidesPerView: 2,
            spaceBetween: 30,
            centeredSlides: true,
            breakpoints: {
                768: {
                    slidesPerView: 4,
                },
                1024: {
                    centeredSlides: false,
                    slidesPerView: 6,
                },
            }
        });
    },

    blockSlides: () => {
        new Swiper('.blockslides', {
            slidesPerView: 1,
            slideClass: 'cmeleon-block-content',
            preventClicks: false,
            preventClicksPropagation: false,
            navigation: {
                prevEl: '.swiper-button-blockslide-prev',
                nextEl: '.swiper-button-blockslide-next',
            },
            pagination: {
                el: '.swiper-pagination-blockslide',
                type: 'bullets',
            },
        });
    },

    gallery: () => {
        var galleryThumbs = new Swiper('.gallery-thumbs', {
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            breakpoints: {
                1024: {
                    centeredSlides: false,
                    slidesPerView: 6,
                },
            }
        });

        new Swiper('.gallery-top', {
            spaceBetween: 10,
            thumbs: {
                swiper: galleryThumbs
            },
            navigation: {
                prevEl: '.swiper-machine-button-prev',
                nextEl: '.swiper-machine-button-next',
            },
        });
    },
}